/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getHistoricalBalanceSnapshots} from '../api'

 export const useQueryGetHistoricalBalanceSnapshots = createReactQueryHook('getHistoricalBalanceSnapshots', getHistoricalBalanceSnapshots)
